import {
  createPlugin,
  createRoutableExtension,
  createApiFactory,
  configApiRef,
  identityApiRef,
} from '@backstage/core-plugin-api';

import { rootRouteRef } from './routes';
import { eksApiRef, EKSClient } from './api';

export const eksPlugin = createPlugin({
  id: 'eks',
  apis: [
    createApiFactory({
      api: eksApiRef,
      deps: { config: configApiRef, identity: identityApiRef },
      factory: ({ config, identity }) =>
        new EKSClient(config.getString('backend.baseUrl'), identity),
    }),
  ],
  routes: {
    root: rootRouteRef,
  },
});

export const EKSPage = eksPlugin.provide(
  createRoutableExtension({
    name: 'EKSPage',
    component: () => import('./components/EKSRouter').then(m => m.EKSRouter),
    mountPoint: rootRouteRef,
  }),
);
